import React, { useEffect, useState } from 'react'
import { Tag, Checkbox, Row, Col, Select, Input, Button, Card, Flex, Tooltip } from 'antd'
import defaultImg from '@/assets/errImg.png'
import { DoubleRightOutlined } from '@ant-design/icons'
import { SDrawerOrModal } from 'shj-components'
import styles from './index.module.less'
import { useParams } from 'react-router-dom'
import { cloneDeep, isArray } from 'lodash-es'

const tagsMap = {
  NATIONAL_UPPLEMENT: 'nationalCss',
}

export default function CheckModal({
  data = [],
  open = false,
  loading = false,
  checkNumber = 0,
  onClose = () => {},
  setData = a => ({}),
  postSpaceData = a => [],
  onSubmit = () => ({}),
  onCheckAll = a => ({}),
}) {
  const params = useParams()
  const type = params.type //当前选材类型
  const [formatData, setFormatData] = useState<Array<any>>([])
  useEffect(() => {
    data.forEach((item: any) => {
      if (Object.keys(item.productSku?.argMap || {})?.length) {
        item.argText = Object.keys(item.productSku?.argMap || {})?.map(
          argCode =>
            item.productSku?.argMap?.[argCode]?.argName +
            '：' +
            item.productSku?.argMap?.[argCode]?.valueName
        )
      }
      if (item.skuDynamicVoList?.length) {
        item.dynamicText = item.skuDynamicVoList?.map(
          item => (item.name || '') + '：' + (item.optionName || '')
        )
      }
      if (item.packDtlList?.length) {
        item.mustChooseList = item.packDtlList
          ?.filter(item => item.required)
          ?.map(item => {
            const sku = item?.skuList?.filter(sku => sku.id === item.selectSkuId)?.[0]
            item.argText = Object.keys(sku?.argMap || {})?.map(
              argCode => sku?.argMap?.[argCode]?.argName + '：' + sku?.argMap?.[argCode]?.valueName
            )
            item.dynamicText = item.materialDynaOptions?.map(
              item => (item.name || '') + '：' + (item.optionName || '')
            )
            return item
          })
        item.noMustChooseList = item.packDtlList
          ?.filter(item => !item.required)
          ?.filter(item => item.checked)
          ?.map(item => {
            const sku = item?.skuList?.filter(sku => sku.id === item.selectSkuId)?.[0]
            item.argText = Object.keys(sku?.argMap || {})?.map(
              argCode => sku?.argMap?.[argCode]?.argName + '：' + sku?.argMap?.[argCode]?.valueName
            )
            item.dynamicText = item.materialDynaOptions?.map(
              item => (item.name || '') + '：' + (item.optionName || '')
            )
            return item
          })
      }
    })
    setFormatData(postSpaceData(data) || [])
  }, [data])

  const singleMaterialCheck = (e: any, index: any) => {
    console.log(index)
    let newData = cloneDeep(data)
    newData[index].checked = e.target.checked
    /*const hasCheckedList = newData.filter(data => data.checked);
    if (!hasCheckedList?.length) {
      setAllSelect(false);
    }*/
    setData(newData)
  }

  const deleteSpace = (record: any, index: any) => {
    const array = cloneDeep(data)
    array.splice(index, 1)
    setData(array)
  }

  const collapseSpace = (index: number) => {
    const newData = cloneDeep(data)
    newData[index].expandDetail = false
    setData(newData)
  }

  const expandSpace = (index: number) => {
    const newData = cloneDeep(data)
    newData[index].expandDetail = true
    setData(newData)
  }

  const handlePrice = (item: any) => {
    let value = item.combinationPrice ?? item.productSkuSalePrice ?? item.saleCustPrice

    return value || value === 0 ? '￥' + value : ''
  }

  const showNationalTagRender = (item: any) => {
    if (item.packDtlList?.length > 0) {
      // 组合产品需判断除了施工项外是否全是国补 判断是否除了施工项都是国补 是则显示 国补标签
      let proList = item.packDtlList
        ?.filter(item => item?.product?.sourceType !== 'CONSTRUCTION')
        ?.filter(item => item.required || (!item.required && item.checked))
      let allNational = false
      if (proList?.length) {
        allNational = proList?.every((item: any) => {
          if (item.selectSkuId) {
            return item?.skuList?.find((sku: any) => sku.id === item.selectSkuId)?.showTags
          }
          return false
        })
      }
      if (allNational) {
        return (
          <div className={tagsMap.NATIONAL_UPPLEMENT}>
            <Tooltip placement="topLeft" title={'国补'}>
              国补
            </Tooltip>
          </div>
        )
      }
    } else {
      let showTags = item?.productSpu?.skuList?.find(
        (sku: any) => sku.id === item.productSkuId
      )?.showTags
      if (showTags && isArray(showTags)) {
        return showTags?.map((tag: any) => {
          return (
            <div className={tagsMap[tag.tagCode]}>
              <Tooltip title={tag.tagName}>{tag.tagName}</Tooltip>
            </div>
          )
        })
      } else {
        return <></>
      }
    }
  }

  const showKitNationalTagRender = (kit: any) => {
    // // 当确定skuid后 显示国补
    let showTags = kit?.skuList?.find((sku: any) => sku.id === kit?.selectSkuId)?.showTags
    if (showTags && isArray(showTags)) {
      return showTags?.map((tag: any) => {
        return (
          <div className={tagsMap[tag.tagCode]}>
            <Tooltip placement="topLeft" title={tag.tagName}>
              {tag.tagName}
            </Tooltip>
          </div>
        )
      })
    } else {
      return <></>
    }
  }

  return (
    <SDrawerOrModal
      mode="drawer"
      open={open}
      onCancel={() => onClose()}
      width={1075}
      title="选材车"
      antdProps={{
        footer: (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                disabled={data.length === 0}
                onClick={e => onCheckAll(e)}
                checked={data?.length ? data.every(el => el.checked) : false}
              >
                全选
              </Checkbox>
              <div>
                <span>已选 {checkNumber} 个</span>
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <Button
                onClick={() => {
                  onClose()
                }}
              >
                取消
              </Button>
              <Button
                loading={loading}
                type="primary"
                disabled={!data?.length}
                onClick={() => {
                  onSubmit()
                }}
                style={{ marginLeft: '10px' }}
              >
                加入选材
              </Button>
            </div>
          </div>
        ),
      }}
    >
      <div className={styles.baseBox}>
        {/* 单个空间选择 */}
        {data &&
          data.map((item: any, index: any) => {
            return (
              <div
                style={{ padding: '15px 15px 5px 10px' }}
                key={index}
                className={`${styles.spaceBox}  ${item.checked ? styles.checkedBox : ''}`}
              >
                <Row className={styles.spaceRow}>
                  <div style={{ display: 'flex' }}>
                    <Checkbox
                      disabled={item.errMessage || item.disabled}
                      checked={item.checked}
                      defaultChecked={item.checked}
                      onChange={e => {
                        singleMaterialCheck(e, index)
                      }}
                    ></Checkbox>
                  </div>
                  <Col span={18} style={{ display: 'flex' }}>
                    {item.listDtl && <div className={styles.colTitle}>已选套件</div>}
                    <div className={styles.choosedImg}>
                      {item.disabled ? (
                        <div className={styles.choosedImgDisabled}>产品已下架失效</div>
                      ) : null}
                      <img
                        className={styles.imgStyle}
                        src={
                          item.productSkuPrimaryImage
                            ? item.productSkuPrimaryImage
                            : item?.productSku?.mainPicUrl || defaultImg
                        }
                      />
                    </div>
                    {/* 报错回显 */}
                    {item?.errMessage && (
                      <div
                        dangerouslySetInnerHTML={{ __html: item?.errMessage }}
                        className={styles.errMessageBox}
                      ></div>
                    )}
                    <div className={styles.colDesc}>
                      <div className={item.errMessage ? styles.disabledFontcolor : styles.skuDesc}>
                        {showNationalTagRender(item)}
                        <Tooltip title={type !== 'SUB' ? item.productSkuName : item.referenceName}>
                          {type !== 'SUB' ? item.productSkuName : item.referenceName}
                        </Tooltip>
                      </div>
                      <div className={item.errMessage ? styles.disabledFontcolor : ''}>
                        {item.productSkuId ? 'SKU: ' + item.productSkuId : ''}
                      </div>
                      {(item?.longDesc || item?.productSpu?.longDesc) && (
                        <p className={styles.skuCard_longDesc}>
                          <span>工艺说明：</span>
                          <Tooltip
                            title={item?.longDesc || item?.productSpu?.longDesc}
                            placement="topLeft"
                          >
                            <span>{item?.longDesc || item?.productSpu?.longDesc}</span>
                          </Tooltip>
                        </p>
                      )}
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className={styles.price}>
                          {/* {item.combinationPrice
                            ? `￥${item.combinationPrice}`
                            : item.productSkuSalePrice
                            ? `￥${item.productSkuSalePrice}`
                            : item.saleCustPrice
                            ? `￥${item.saleCustPrice}`
                            : null} */}
                          {handlePrice(item) +
                            `${item.productSpuUnitName || item.unitName ? ' / ' + (item.productSpuUnitName || item.unitName) : ''}`}
                        </div>
                        <div style={{ marginLeft: '10px', lineHeight: '24px', height: '24px' }}>
                          数量:{' '}
                          {formatData?.[index]?.formatSpaceList?.reduce(
                            (pre, next) => pre + (next?.budgetQtyValue * 100 || 0),
                            0
                          ) / 100 || 0}
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col flex={1} style={{ textAlign: 'right' }}>
                    <Button danger size="small" onClick={() => deleteSpace(item, index)}>
                      移除
                    </Button>
                  </Col>
                </Row>
                {item?.argText?.length || item?.dynamicText?.length ? (
                  <Row
                    style={{
                      marginTop: '16px',
                      marginLeft: 26,
                      padding: '8px',
                      lineHeight: '22px',
                      fontSize: '14px',
                      color: 'rgba(135, 136, 138, 1)',
                      backgroundColor: 'rgba(245, 245, 245, 1)',
                    }}
                  >
                    {item?.argText?.length ? (
                      <span>{'规格：' + item?.argText.join('； ')}</span>
                    ) : null}
                    <br />
                    {item?.dynamicText?.length ? (
                      <span>{'报价属性；' + item?.dynamicText.join('； ')}</span>
                    ) : null}
                  </Row>
                ) : null}
                <Row
                  style={{
                    marginTop: '16px',
                    marginLeft: 26,
                    paddingBottom: '10px',
                  }}
                >
                  {data[index]?.budgetItemList?.length &&
                    !data[index]?.budgetItemList?.[0]?.isRoot && (
                      <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                        {/* 空间配置 */}
                        <span
                          style={{ border: '0px', paddingLeft: 0 }}
                          disabled={item.errMessage}
                          color="primary"
                          size="small"
                          className={styles.themeColor}
                        >
                          应用空间（
                          {data[index]?.spaceChecked?.length +
                            ' / ' +
                            (data[index]?.budgetItemList?.length || 0)}
                          ）
                        </span>
                      </Col>
                    )}
                  {data[index].spaceChecked && data[index].spaceChecked.length !== 0 ? (
                    <>
                      <Col span={17} style={{ display: 'flex', overflow: 'auto' }}>
                        {/* 已选择空间 */}
                        {data[index].spaceChecked &&
                          data[index].spaceChecked.map((elTag, elTagIndex) => {
                            return (
                              <Tag
                                key={elTag}
                                className={styles.garyFontColor}
                                style={{
                                  height: '100%',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                {data[index]?.budgetItemList.find(el => el.id == elTag).showName}
                              </Tag>
                            )
                          })}
                      </Col>
                    </>
                  ) : (
                    <Col span={17} style={{ display: 'flex' }}></Col>
                  )}
                  {type !== 'SUB' && item.productSpu?.prodType === 'PRODUCT_GROUP' && (
                    <>
                      {data[index].expandDetail ? (
                        <Col
                          onClick={() => collapseSpace(index)}
                          flex={'space-between'}
                          style={{
                            height: '24px',
                            color: 'var(--theme-color)',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            cursor: 'pointer',
                          }}
                          span={3}
                        >
                          收起产品明细
                          <DoubleRightOutlined
                            style={{ transform: 'rotate(-90deg)', marginLeft: 4 }}
                          />
                        </Col>
                      ) : (
                        <Col
                          onClick={() => expandSpace(index)}
                          flex={'space-between'}
                          style={{
                            height: '24px',
                            color: 'var(--theme-color)',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            cursor: 'pointer',
                          }}
                          span={3}
                        >
                          展开产品明细
                          <DoubleRightOutlined
                            style={{ transform: 'rotate(90deg)', marginLeft: 4 }}
                          />
                        </Col>
                      )}
                    </>
                  )}
                </Row>
                {data[index].expandDetail ? (
                  <>
                    <div className={styles.KitDetailDialogBox}>
                      {item?.mustChooseList?.length
                        ? item?.mustChooseList?.map((kit: any, index: any) => {
                            if (kit?.allowView) {
                              return (
                                <div className={styles.orderDetail} key={'kit' + index}>
                                  <div className={styles.orderDetailInfoBox}>
                                    <div className={styles.imgBox}>
                                      <img src={kit?.mainPicUrl} className={styles.img} />
                                    </div>
                                    <div className={styles.orderDetailInfo}>
                                      <div className={styles.infoTitle}>
                                        <div className={styles.descTitle}>
                                          {showKitNationalTagRender(kit)}
                                          <Tooltip title={kit?.prodName} placement="topLeft">
                                            <span> {kit?.prodName}</span>
                                          </Tooltip>
                                        </div>
                                      </div>
                                      <div className={styles.kitId}>{kit.id}</div>
                                      <div className={styles.footInfo}>
                                        {kit.product?.brandName && (
                                          <div className={styles.houseInfo}>
                                            <div>
                                              <span>品牌：{kit.product?.brandName}</span>
                                              {kit?.argText?.length ? (
                                                <span>{'； ' + kit?.argText.join('； ')}</span>
                                              ) : null}
                                              {kit?.dynamicText?.length ? (
                                                <span>{'； ' + kit?.dynamicText.join('； ')}</span>
                                              ) : null}
                                            </div>
                                          </div>
                                        )}
                                        {(kit?.longDesc || kit?.product?.longDesc) && (
                                          <p className={styles.skuCard_longDesc}>
                                            <span>工艺说明：</span>
                                            <Tooltip
                                              title={
                                                kit?.longDesc || kit?.product?.longDesc?.longDesc
                                              }
                                              placement="topLeft"
                                            >
                                              <span>
                                                {kit?.longDesc || kit?.product?.longDesc?.longDesc}
                                              </span>
                                            </Tooltip>
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                    {/* )} */}
                                  </div>
                                </div>
                              )
                            }
                          })
                        : null}
                    </div>
                    {item?.noMustChooseList?.length ? (
                      <div
                        style={{
                          backgroundColor: 'rgba(0, 36, 90, 0.06)',
                          padding: '5px 0 5px 20px',
                          color: 'rgba(45, 45, 46, 1)',
                          fontSize: '12px',
                          lineHeight: '20px',
                          marginTop: '8px',
                        }}
                      >
                        可选项
                      </div>
                    ) : null}
                    <div className={styles.KitDetailDialogBox}>
                      {item?.noMustChooseList?.length
                        ? item?.noMustChooseList?.map((kit: any, index: any) => {
                            if (kit?.allowView) {
                              return (
                                <div className={styles.orderDetail} key={'kit' + index}>
                                  <div className={styles.orderDetailInfoBox}>
                                    <div className={styles.imgBox}>
                                      <img src={kit?.mainPicUrl} className={styles.img} />
                                    </div>
                                    <div className={styles.orderDetailInfo}>
                                      <div className={styles.infoTitle}>
                                        <div className={styles.descTitle}>
                                          {showKitNationalTagRender(kit)}
                                          <Tooltip title={kit?.prodName} placement="topLeft">
                                            <span> {kit?.prodName}</span>
                                          </Tooltip>
                                        </div>
                                      </div>
                                      <div className={styles.kitId}>{kit.id}</div>
                                      <div className={styles.footInfo}>
                                        {kit.product?.brandName && (
                                          <div className={styles.houseInfo}>
                                            <div>品牌：{kit.product?.brandName}</div>
                                            {kit?.argText?.length ? (
                                              <span>{'； ' + kit?.argText.join('； ')}</span>
                                            ) : null}
                                            {kit?.dynamicText?.length ? (
                                              <span>{'； ' + kit?.dynamicText.join('； ')}</span>
                                            ) : null}
                                          </div>
                                        )}
                                        {(kit?.longDesc || kit?.product?.longDesc) && (
                                          <p className={styles.skuCard_longDesc}>
                                            <span>工艺说明：</span>
                                            <Tooltip
                                              title={
                                                kit?.longDesc || kit?.product?.longDesc?.longDesc
                                              }
                                              placement="topLeft"
                                            >
                                              <span>
                                                {kit?.longDesc || kit?.product?.longDesc?.longDesc}
                                              </span>
                                            </Tooltip>
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                    {/* )} */}
                                  </div>
                                </div>
                              )
                            }
                          })
                        : null}
                    </div>
                  </>
                ) : null}
              </div>
            )
          })}
      </div>
    </SDrawerOrModal>
  )
}
